/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Message_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Vessel, port, dates and the inspection or service you need" |
*
* @param {Contact_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_message_placeholder = /** @type {((inputs?: Contact_Message_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Message_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("船舶、港口、日期以及您需要的检查或服务")
	return /** @type {LocalizedString} */ ("Vessel, port, dates and the inspection or service you need")
});